import { getDefaultPieFormatting } from "@/containers/E4ImpactMBA/charts/pie";

const transformData = [
    {
        name: 'Menswear',
        value: 'Item 1'
    },
    {
        name: 'Womenswear',
        value: 'Item 2'
    },
    {
        name: 'Accessories & others',
        value: 'Item 3'
    }
];

/**
 * question: What is your specialty?
 * == baseline
 * question73
 * 
 * @param props 
 * @returns 
 */
export const specialtyFashionAndTextileSectorChartCalculation = (props: any) => {    
    return getDefaultPieFormatting(
        'Specialty of the fashion and textile sector',
        transformData.map(({name, value}) => ({
            name,
            y: props.baselineSubmissions.filter((submission: any) => {
                for (let i = 0; i < transformData.length; i++) {
                    if (submission[`question73_${i}`] === value) {
                        return true;
                    }
                }
                
                return false;
            }).length
        }))
    )
}